import { useTranslation } from "react-i18next";
import { Checkbox } from "@/components/ui/checkbox";
import { Field, FieldLabel } from "@/components/ui/field";

/**
 * Draws nothing below two options: above a single checkbox it is a second control for one
 * decision, which is the shape a periode with one wedstrijddag takes.
 */
export function SelectAllCheckbox({
  id,
  label,
  total,
  selected,
  disabled,
  onChange,
}: {
  id: string;
  label?: string;
  total: number;
  selected: number;
  disabled?: boolean;
  /** `true` selects every option, `false` clears them. */
  onChange: (alles: boolean) => void;
}) {
  const { t } = useTranslation();

  if (total < 2) {
    return null;
  }

  const alles = selected === total;

  return (
    <Field orientation="horizontal" className="w-auto gap-2">
      <Checkbox
        id={id}
        checked={alles ? true : selected === 0 ? false : "indeterminate"}
        disabled={disabled}
        onCheckedChange={() => onChange(!alles)}
      />
      <FieldLabel htmlFor={id} className="font-normal text-muted-foreground">
        {label ?? t("selectAll.label")}
        <span className="text-xs">{t("selectAll.count", { selected, total })}</span>
      </FieldLabel>
    </Field>
  );
}
